import script from "./RegionShapeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionShapeForm.vue?vue&type=script&setup=true&lang=js"

import "./RegionShapeForm.vue?vue&type=style&index=0&id=452315bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452315bb"]])

export default __exports__